export default __webpack_public_path__ + "static/media/HomePageIntro.35a26399.mp4";